import { UpdateUsername } from '@wellesley/auth'

export const UpdateUsernamePage = () => <UpdateUsername />
